import Grid from '@material-ui/core/Grid';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';

import Collection from '../Model/Collection';

import ItemTableRow from '../Components/ItemTableRow';
import ProjectGroupCard from '../Admin/Components/ProjectGroupCard';
import ProjectGroupCollectionFields from '../Model/ProjectGroupCollectionFields';
import ProjectGroupDialog from '../Admin/Components/ProjectGroupDialog';
import ProjectGroupCreationDialog from '../Admin/Components/ProjectGroupCreationDialog';

import {
  GetProjectGroupsPathForApi,
  GetProjectGroupPathForApi,
} from '../Util/api';
import {
  GetProjectGroupsPath,
} from '../Util/PathHelper';
import {
  HandleRouteToProjectGroup,
} from '../Util/ProjectGroups';

import API from '../Util/api';

import {
  GetDateValue,
} from '../Util/Properties';

export class ProjectGroups_Collection extends Collection {
  constructor(props, onSetState, onApiError, isWorkspace, isProjects, organizationId, 
    projectId, context, onItemTitleChange) {
    
    if (typeof organizationId !== "string") {
      console.log("Warning: organizationId required and not found");
    }
    if (typeof projectId !== "string") {
      console.log("Warning: projectId required and not found");
    }
    super(props, onSetState, onApiError, isWorkspace, isProjects, organizationId, projectId);

    this.handleItemTitleChange = onItemTitleChange;

    this.PageTitle = "Project Groups";
    this.ContentUri = GetProjectGroupsPathForApi(organizationId, projectId);
    this.CollectionName = "ProjectGroups";
    this.ItemsName = "ProjectGroups";
    this.ItemName = `Project Group`;
    this.DefaultViewType = "List";
    this.AllowSelect = true;
    this.ProjectGroupsForDialog = [];

    this.context = context;
  }

  HandleGetCollectionFieldsPromise = () => Promise.resolve(ProjectGroupCollectionFields);

  HandleGetHeadCells = (items, sensitiveFields) => [
    { id: 'Name', sortId: 'Meta_text_kw256lc[Name].keyword', numeric: false, label: 'Name' },
    { id: 'CreatedOn', sortId: 'Meta_date_str256[CreatedOn].string', numeric: false, label: 'Created' },
  ];

  HandleGetCardGridItems = (items, sensitiveFields, classes, theme, onSelect, selectedIDs, onAction, postActionData, sortType, sortDescending) => {
    return (items && items.length)
      ? items
        .map(i => {
          return (
            <Grid item key={i.ID} sm={12} md={6} lg={4} xl={3} className={classes.cardGridItem}>
              <ProjectGroupCard
                ProjectGroup={i}
                onCardAction={() => HandleRouteToProjectGroup(this.props, this.ProjectID, i.ID)}
                onSelect={() => onSelect(i.ID)}
                selected={selectedIDs.indexOf(i.ID) > -1}
              />
            </Grid>
          );
        }) 
      : [];
  }

  HandleGetTableRows = (headCells, items, sensitiveFields, classes, theme, onSelect, selectedIDs, onAction, postActionData, sortType, sortDescending) => {
    return (items && items.length)
      ? items
        .map(i => {
          const labelId = `label_${i.Name}`;
          return (
            <ItemTableRow key={`k_${i.ID}`}
              onItemClick={() => HandleRouteToProjectGroup(this.props, this.ProjectID, i.ID)}
              onSelect={() => onSelect(i.ID)}
            >
              <TableCell className={classes.tableCell_FirstCell} padding="checkbox">
                <Checkbox
                  color="secondary"
                  onClick={event => { event.stopPropagation(); onSelect(i.ID); }}
                  checked={selectedIDs.indexOf(i.ID) > -1}
                  inputProps={{ 'aria-labelledby': labelId, style:{zIndex:0} }}
                />
              </TableCell>
              <TableCell className={classes.tableCell} component="th" id={labelId} scope="row" padding="none">
                {i.Name}
              </TableCell>
              <TableCell className={classes.tableCell}>{GetDateValue(i.CreatedOn)}</TableCell>
            </ItemTableRow>
          );
        }) 
      : [];
  }

  HandleItemsChanged = items => {
    this.ProjectGroupsForDialog = items || [];
    this.handleDisplayProjectGroupDialogIfApplicable(null, items);
  }

  handleDisplayProjectGroupDialogIfApplicable = (projectGroupId, projectGroups) => {
    if (!projectGroupId) {
      projectGroupId = this.props.match.params.collectionItemID;
    }
    if (projectGroupId) {
      const displayGroupDialog = (projectGroup, extraState) => {
        this.setState({
          ProjectGroupForProjectGroupDialog: projectGroup,
          ProjectGroupDialogIsOpen: true,
          ...extraState,
        });
        if (this.handleItemTitleChange) {
          this.handleItemTitleChange(projectGroup.Name);
        }
      }
      if (!projectGroups) {
        projectGroups = [...this.ProjectGroupsForDialog];
      }
      let groupFinder = projectGroups.filter(g => g.ID === projectGroupId);
      if (!groupFinder.length) {
        API.get(GetProjectGroupPathForApi(this.OrganizationID, this.ProjectID, projectGroupId))
          .then(resp => {
            displayGroupDialog(resp.data, {
              ForcePrependItems: [resp.data],
            });
          })
          .catch(err => {
            this.handleApiError(err);
            this.handleProjectGroupDialogClosed();
          });
      } else {
        displayGroupDialog(groupFinder[0]);
      }
    }
  }

  handleProjectGroupDialogClosed = () => {
    const stateToUpdate = {
      ProjectGroupDialogIsOpen: false,
      ShowDialogProgressIndicatorImmediately: false,
    };
    this.setState(stateToUpdate);
    
    const newPath = GetProjectGroupsPath(this.ProjectID);
    if (this.props.location.pathname !== newPath) {
      this.props.history.push(newPath, { ...this.props.location.state, ...stateToUpdate });
    }
    if (this.handleItemTitleChange) {
      this.handleItemTitleChange(null);
    }
  }

  HandleGetDialogContent = state => {
    if (state.ProjectGroupDialogIsOpen) {
      return (
        <ProjectGroupDialog
          open={state.ProjectGroupDialogIsOpen || false}
          ProjectGroup={state.ProjectGroupForProjectGroupDialog}
          onProjectGroupRevised={this.HandleItemRevised}
          onApiError={this.handleApiError}
          onClose={this.handleProjectGroupDialogClosed}
          showProgressIndicatorImmediately={state.ShowDialogProgressIndicatorImmediately}
        />
      );
    }
    else if (state.AddProjectGroupDialogIsOpen) {
      return (
        <ProjectGroupCreationDialog
          organizationId={this.OrganizationID}
          projectId={this.ProjectID}
          open={state.AddProjectGroupDialogIsOpen || false}
          onCreated={this.handleProjectGroupCreated}
          onClose={() => this.handleAddProjectGroupDialogClosed()}
          onApiError={this.handleApiError}
        />
      );
    }
  }

  handleAddProjectGroupDialogClosed = () => {
    this.setState({
      AddProjectGroupDialogIsOpen: false,
    })
  }

  handleProjectGroupCreated = projectGroup => {
    this.handleAddProjectGroupDialogClosed();
    if (!projectGroup) {
      return;
    }
    this.setState({
      ForcePrependItems: [projectGroup],
    });
  }

  HandleCreateNew = () => {
    this.setState({
      AddProjectGroupDialogIsOpen: true,
    });
  }

  // Returns whether further path changes can occur.
  updateProps(props) {
    Collection.prototype.updateProps.bind(this)(props);

    if (this.props.match.params.collectionItemID && !this.prevProps.match.params.collectionItemID) {
      this.handleDisplayProjectGroupDialogIfApplicable(null, null);
      return false;
    } else if (!this.props.match.params.collectionItemID && this.prevProps.match.params.collectionItemID) {
      this.handleProjectGroupDialogClosed();
      return false;
    }

    return true;
  }
}